module.exports = __webpack_public_path__ + "img/spotangels-logo-editor.334ff7fc.svg";